module.exports = __webpack_public_path__ + "media/images/about_us/about-us-mobile-73b94b915e498873741a9f7e2699c72b.jpg";